import produce from 'immer';
import create from 'zustand';

// Initial store value
const GRADE_STUDENT_INITIAL = {
	// Request data
	data: {
		subjectId: 0,
		courseId: 0,
		startDate: null,
		endDate: null,
		additional: false
	},

	// Collected subjects and courses
	subjects: [],
	courses: []
};

export const useGradeStudentsAssignStore = create(set => ({
	...GRADE_STUDENT_INITIAL,

	// Handle data change
	onChange: ({ name, value }) => set(produce(state => {
		state.data[name] = value;
	})),

	// Initialize subjects state
	onInitSubjects: (subjects) => set(produce(state => {
		state.subjects = subjects;
	})),

	// Initialize courses state
	onInitCourses: (courses) => set(produce(state => {
		state.courses = courses;
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_STUDENT_INITIAL
	})
}));